import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';

const STAGE_LABEL_KEYS = {
  GROUP_STAGE: 'eventodeportivo_tablaposiciones_texto_titulo_fasegrupos',
};

export const getStageLabel = ({ stage, stages, translations }) => {
  const stageFromService = stages?.find(({ code }) =>
    code
      ?.split(',')
      .map(stageCode => stageCode.trim())
      .includes(stage),
  );
  if (stageFromService?.label) return stageFromService.label;

  const stageKey = STAGE_LABEL_KEYS[stage];
  return stageKey ? getTranslationEmptyOrNullKey(stageKey, translations) : null;
};
